/* eslint-disable */
import _ from 'underscore';
import CopyPasteViewModel from '@bingads-webui-static-legacy/bulk-edit/viewmodel/copypaste/copyPaste';
import adTemplate from '@bingads-webui-static-legacy/bulk-edit/template/copypaste/copyPasteAd.pug';
import keywordTemplate from '@bingads-webui-static-legacy/bulk-edit/template/copypaste/copyPasteKeyword.pug';
import campaignTemplate from '@bingads-webui-static-legacy/bulk-edit/template/copypaste/copyPasteCampaign.pug';
import adGroupTemplate from '@bingads-webui-static-legacy/bulk-edit/template/copypaste/copyPasteAdGroup.pug';
import assetGroupTemplate from '@bingads-webui-static-legacy/bulk-edit/template/copypaste/copyPasteAssetGroup.pug';
import BaseView from '@bingads-webui-static-legacy/bulk-edit/view/bulkEditJob';
import helpDirective from '@bingads-webui-static-legacy/directive/help';
import PageContext from '@bingads-webui-static-legacy/page-context';
import * as datePicker from '@bingads-webui-campaign/campaigns-date-picker';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var pasteOptions = [{
  flag: function (ko_model) {
    return !ko_model.includeBids();
  },
  data: {
    '@odata.type': '#Model.NumericAction',
    Property: 'Bid/Amount',
    ActionType: 'SetToAmount',
    Value: null,
    Limit: null
  }
}, {
  flag: function (ko_model) {
    return !ko_model.includeDestinationURLs();
  },
  data: {
    '@odata.type': '#Model.TextAction',
    Property: 'DestinationUrl',
    ActionType: 'Set',
    Value: null
  }
}, {
  flag: function (ko_model) {
    return ko_model.pauseAfterPasting();
  },
  data: {
    '@odata.type': '#Model.TextAction',
    Property: 'Status',
    ActionType: 'Set',
    Value: 'Paused'
  }
}];
var tabs = {
  'ad': {
    key: 'AdTitle',
    secondary: 'AdText',
    progress: i18n.getString('BulkEdit_PasteAds_ProgressText'),
    template: adTemplate
  },
  'keyword': {
    key: 'Keyword',
    progress: i18n.getString('BulkEdit_PasteKeywords_ProgressText'),
    template: keywordTemplate
  },
  'campaign': {
    key: 'Campaign',
    progress: i18n.getString('BulkEdit_PasteCampaigns_ProgressTextWithoutTotalEntities'),
    template: campaignTemplate
  },
  'adgroup': {
    key: 'AdGroup',
    progress: i18n.getString('BulkEdit_PasteAdGroups_ProgressTextWithoutTotalEntities'),
    template: adGroupTemplate
  },
  'assetgroup': {
    key: 'AssetGroup',
    progress: i18n.getString('BulkEdit_PasteAssetGroups_ProgressTextWithoutTotalEntities'),
    template: assetGroupTemplate
  }
};
var clipboard = null;
var formatCampaignAdGroup = function (campaign, adgroup) {
  var value = campaign ? campaign : '';
  value += ' >';
  if (adgroup) {
    value += '<br/>';
    value += adgroup;
  }
  return value;
};
var view = BaseView.extend({
  initialize: function (options) {
    if (options.perfMarker) {
      this.perfMarker = options.perfMarker;
    }
    BaseView.prototype.initialize.apply(this, arguments);
    this.startDatePicker = new datePicker.CampaignsDatePicker({
      minDate: new Date(),
      selectedDate: new Date()
    });
    var nextYear = new Date();
    nextYear.setFullYear(nextYear.getFullYear() + 1);
    this.endDatePicker = new datePicker.CampaignsDatePicker({
      minDate: new Date(),
      selectedDate: nextYear
    });
    this.ko_model = new CopyPasteViewModel(this.model, this.startDatePicker, this.endDatePicker);
    clipboard = this.model.get('content');
    this.ko_model.contentType(clipboard.type);
    this.template = tabs[clipboard.type] && tabs[clipboard.type].template;
  },
  render: function () {
    if (this.perfMarker) {
      this.perfMarker.willRender();
    }
    BaseView.prototype.render.apply(this, arguments);
    helpDirective.run(this.$el);
    this.startDatePicker.render();
    this.$('.start-date-picker').html(this.startDatePicker.$el);
    this.endDatePicker.render();
    this.$('.end-date-picker').html(this.endDatePicker.$el);
    var tmp = this.endDatePicker.getChild('date-picker');
    var that = this;
    tmp.on('rendered', function () {
      tmp.datePicker.enable(false);
      that.ko_model.endDateModification.subscribe(function (endDateModification) {
        var shouldEnable = endDateModification === 'Selected';
        tmp.datePicker.enable(shouldEnable);
      });
      if (that.perfMarker) {
        that.perfMarker.done();
      }
    });
    return this;
  },
  setAction: function () {
    var adgroup = PageContext.CurrentAdGroup;
    if (adgroup) {
      this.setActionWithinAdGroup(adgroup);
    } else {
      var campaign = PageContext.CurrentCampaign;
      if (campaign) {
        this.setActionOutsideAdGroup(campaign);
      } else {
        this.setActionOutsideAdGroup(null);
      }
    }
  },
  setActionWithinAdGroup: function (adgroup) {
    switch (this.ko_model.contentType()) {
      case 'keyword':
        this.model.set('Entity', 'Keyword');
        break;
      case 'ad':
        this.model.set('Entity', 'Ad');
        break;
      default:
        return;
    }
    this.setActionWithAdGroupId(adgroup.Id);
  },
  setActionOutsideAdGroup: function (campaign) {
    switch (this.ko_model.contentType()) {
      case 'adgroup':
        this.model.set('Entity', 'AdGroup');
        break;
      case 'campaign':
        this.model.set('Entity', 'Campaign');
        break;
      case 'assetgroup':
        this.model.set('Entity', 'AssetGroup');
        break;
      default:
        return;
    }
    var campaignId = campaign ? campaign.Id : null;
    this.setActionWithDates(campaignId);
  },
  setActionWithAdGroupId: function (adgroupId) {
    var action = {
      Actions: [{
        '@odata.type': '#Model.CopyAction',
        DestinationParentEntityIds: adgroupId ? [adgroupId] : null
      }],
      EditCopy: false
    };
    _.each(pasteOptions, (function (option) {
      if (option.flag(this.ko_model)) {
        action.Actions.push(option.data);
      }
    }).bind(this));
    this.model.set('BatchAction', action);
  },
  setActionWithDates: function (campaignId) {
    var action = {
      Actions: [{
        '@odata.type': '#Model.CopyAction',
        DestinationParentEntityIds: campaignId ? [campaignId] : [0],
        StartDate: this.ko_model.adjustStartAndEndDates() ? this.startDatePicker.getState().selectedDate : null,
        EndDate: this.ko_model.endDateModification() === 'Selected' ? this.endDatePicker.getState().selectedDate : null,
        EndDateAction: this.ko_model.adjustStartAndEndDates() ? this.ko_model.endDateModification() : 'NoChange'
      }],
      EditCopy: false
    };
    _.each(pasteOptions, (function (option) {
      if (option.flag(this.ko_model)) {
        action.Actions.push(option.data);
      }
    }).bind(this));
    this.model.set('BatchAction', action);
  },
  getCampaignId: function () {
    return clipboard ? clipboard.campaignId : -1;
  },
  getAdGroupId: function () {
    return clipboard ? clipboard.adGroupId : -1;
  },
  getIdFilter: function () {
    return clipboard ? clipboard.filters : null;
  },
  getDateRangeQuery: function () {
    return clipboard ? clipboard.dateRange : null;
  },
  getProgressText: function () {
    var tab = tabs[this.ko_model.contentType()];
    return tab && tab.progress || '';
  },
  formatErrors: function (errors) {
    if (!errors) {
      return errors;
    }
    var entityKey = tabs[this.ko_model.contentType()] && tabs[this.ko_model.contentType()].key;
    var secondaryKey = tabs[this.ko_model.contentType()] && tabs[this.ko_model.contentType()].secondary;
    _.each(errors, function (error) {
      var copyFromCampaign, copyFromAdGroup, pasteToCampaign, pasteToAdGroup;
      var entity = entityKey ? _.find(error.EntityKey, function (item) {
        return item.Key === entityKey;
      }) : null;
      if (!entity) {
        entity = _.find(error.EntityKey, function (item) {
          return item.Key === secondaryKey;
        });
      }
      error.data = [];
      error.data.push({
        value: entity && entity.Value ? entity.Value : '',
        isHtml: false
      });
      _.each(error.Changes, function (change) {
        switch (change.Property) {
          case 'AdgroupName':
            copyFromAdGroup = change.OriginalValue;
            pasteToAdGroup = change.NewValue;
            break;
          case 'CampaignName':
            copyFromCampaign = change.OriginalValue;
            pasteToCampaign = change.NewValue;
            break;
          default:
            break;
        }
      });
      error.data.push({
        value: formatCampaignAdGroup(copyFromCampaign, copyFromAdGroup),
        isHtml: true
      });
      error.data.push({
        value: formatCampaignAdGroup(pasteToCampaign, pasteToAdGroup),
        isHtml: true
      });
    });
    return errors;
  }
});
export default view;

